import React from "react";
import Modal from "../../bootstrap/modal";
import { Row, Col, Button } from "react-bootstrap";
import "../../../style/custom/success-request.scss";

export default function SuccessRequest(props) {
  const { onClose, text } = props;
  return(
    <Modal
      show
      className="success-request-notification"
      onClose={async () => onClose()}
    >
      <Row className="success-request-heading">
        <Col>
          <p className="success-request-title">{"Update Successful"}</p>
        </Col>
      </Row>
      <Row className="success-request-body">
        <Col className="success-request-body-col">
          <i
            className="fas fa-check-circle"
          />
          <p className="success-request-content">
            {`Successfully changed ${text}.`}
          </p>
        </Col>
      </Row>
      <Row className="success-request-footer">
        <Col className="success-request-col">
          <Button
            type="button"
            className="blue-btn-outline"
            onClick={async () => {
              return onClose();
            }}
          >
            {"Ok"}
          </Button>
        </Col>
      </Row>
    </Modal>
  );
};